import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import {authPath, noFoundPath, rootAuthPath, rootMainPath} from './paths';
import {SignIn, SignUp, Successfully, PassRecovery} from '../features/Auth';
import PassReset from '../features/Auth/PassReset/PassReset';
import SuccessfullyRecovery from '../features/Auth/SuccessfullyRecovery';

const AuthRoutes = () => {
  if (localStorage.token) return <Redirect to={rootMainPath} />;

  return (
    <Switch>
      <Redirect from={rootAuthPath} exact to={authPath.signIn} />
      <Route path={authPath.signIn} exact component={SignIn} />
      <Route path={authPath.signUp} exact component={SignUp} />
      <Route path={authPath.reset} exact component={PassReset} />
      <Route path={authPath.successfully} exact component={Successfully} />
      <Route path={authPath.successfullyRecovery} exact component={SuccessfullyRecovery} />
      <Route path={authPath.passRecovery} exact component={PassRecovery} />
      <Route path={'*'} render={() => <Redirect to={noFoundPath} />} />
    </Switch>
  );
};

export default AuthRoutes;
